import zh from './zh';
export default {
    ...zh,
    lang: 'en',
    frame: {
        ...zh.frame,
        'desc_title': 'About this website',
        tabbar: {
            ...zh.frame.tabbar,
            'index': 'Welcome',
            'about': 'About',
            'trends': 'Trends'
        },
        open: {
            ...zh.frame.open,
            'qqgroup': 'QQ-Group',
            'liveroom': 'Live Room',
            'biligroup': 'B-Group'
        }
    },
    app: {
        ...zh.app,
        'title': 'Hail Gu Gu - To the best Pigeons !',
        "desc": [
            "This website is an aid station for painting honeymoons.//googoo goo. what is going on? I believe everyone is familiar with this website, but what is going on when this website is the aid station for painting honeymoons.//googoo goo, let Xiao bian take you to know it together.",
            "This website is an aid station for painting cuckoo. In fact, it is because painting cuckoo kite is the best in the world. People may be surprised how this website is an aid station for painting cuckoo. But the fact is, Xiao Bian was also very surprised.",
            "This is what this website is about to be the aid station for painting honeymoons.//googoo goo. what do you think? please tell xiaobian in the comment area to discuss it together!"
        ]
    },
}